export default "__VITE_ASSET__DACbuj4V__"